<app-breadcrumb
  [master]="'Administracja'"
  [parentName]="'Dobryagent.pl'"
  [name]="'Ustawienia powiadomień'">
</app-breadcrumb>

<div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
  <div
    fxLayout="column"
    fxFlex="50"
    [formGroup]="form">

    <mat-card>
      <div class="settings-header">
        <div>
          <h3>Powiadomienia o zmianach wizytówki DA</h3>
          <p>
            Zdefiniuj adresy e-mail, na które będą wysyłane powiadomienia po zgłoszeniu zmian
            w wizytówce DobryAgent przez Agenta.
          </p>
        </div>

        <button
          *ngIf="!editMode && !loading"
          mat-stroked-button
          color="primary"
          type="button"
          (click)="startEdit()">
          <span>Edytuj</span>
        </button>
      </div>

      <div *ngIf="loading" class="loading-box">
        <mat-spinner diameter="32"></mat-spinner>
        <span>Pobieranie ustawień...</span>
      </div>

      <ng-container *ngIf="!loading">

        <!-- WIDOK -->
        <ng-container *ngIf="!editMode">
          <div class="view-section">
            <h4>Adresy odbiorców</h4>

            <mat-chip-list *ngIf="recipients.length > 0; else noRecipients">
              <mat-chip
                color="accent"
                selected
                *ngFor="let recipient of recipients">

                <span *ngIf="recipient.fullName">
                  {{ recipient.fullName }} —
                </span>

                {{ recipient.email }}
                <span *ngIf="recipient.phoneNumber">
                  — {{ recipient.phoneNumber }}
                </span>
              </mat-chip>
            </mat-chip-list>

            <ng-template #noRecipients>
              <div class="empty-state">
                Brak skonfigurowanych adresów e-mail.
              </div>
            </ng-template>
          </div>
        </ng-container>

        <!-- EDYCJA -->
        <ng-container *ngIf="editMode">
          <div formArrayName="recipients" class="emails-list">
            <div
              class="email-row"
              *ngFor="let control of recipientsArray.controls; let i = index"
              [formGroupName]="i"
              fxLayout="row"
              fxLayout.lt-md="column"
              fxLayoutGap="15px"
              fxLayoutAlign="start start">

              <app-dict-users
                fxFlex="30"
                label="Użytkownik"
                [multiple]="false"
                [control]="getUserControl(i)"
                (selectedUser)="selectedUser($event, i)">
              </app-dict-users>

              <mat-form-field fxFlex="35" class="email-field">
                <mat-label>Adres e-mail</mat-label>

                <input
                  matInput
                  type="email"
                  formControlName="email"
                  placeholder="np. marta.gora@asf.com.pl"
                  (input)="onEmailManualChange(i)"
                />

                <mat-error *ngIf="getEmailControl(i).hasError('required')">
                  Adres e-mail jest wymagany
                </mat-error>

                <mat-error *ngIf="getEmailControl(i).hasError('email')">
                  Podaj prawidłowy adres e-mail
                </mat-error>
              </mat-form-field>

              <mat-form-field fxFlex="25" class="phone-field">
                <mat-label>Telefon</mat-label>

                <input
                  matInput
                  type="text"
                  formControlName="phoneNumber"
                  placeholder="+48 500 200 300"
                  prefix="+48" mask=" 000 000 000"
                />
              </mat-form-field>

              <button
                mat-icon-button
                color="warn"
                type="button"
                [disabled]="processingRequest"
                matTooltip="Usuń odbiorcę"
                (click)="removeRecipient(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <div class="actions-row">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              [disabled]="processingRequest"
              (click)="addRecipient()">
              <mat-icon>add</mat-icon>
              <span>Dodaj odbiorcę</span>
            </button>
          </div>

          <div class="footer-actions">
            <button
              mat-stroked-button
              color="warn"
              type="button"
              [disabled]="processingRequest"
              (click)="cancel()">
              <span>Anuluj</span>
            </button>

            <button
              mat-flat-button
              color="primary"
              type="button"
              [disabled]="processingRequest"
              [class.spinner]="processingRequest"
              (click)="save()">
              <span>Zapisz ustawienia</span>
            </button>
          </div>
        </ng-container>

      </ng-container>
    </mat-card>
  </div>
</div>
